import { IGroupAlertBehavior, IGroupAlertBehaviorSpecifiable } from "../../../../../../../documaker/domain/format/objects";
import { IObjectBeanGroupAlertValidatable } from "../../../beans/objects";

export class GroupAlertBehaviorTranslator {
  from(bean: IObjectBeanGroupAlertValidatable): IGroupAlertBehavior {
    return {
      isEnable: (bean["@alert-group"] && (0 < bean["@alert-group"].length)),
      name: bean["@alert-group"] ? bean["@alert-group"] : "",
    };
  }

  to(o: IGroupAlertBehaviorSpecifiable) {
    return {
      alertGroup: o.groupAlertBehavior.isEnable
        ? o.groupAlertBehavior.name
        : undefined,
    };
  }
}
